/** Glock 17. 9x19 mm service pistol: fast up, honest to the second lane, tired past it. */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const GLOCK17 = {
  id: 'glock17',
  label: 'Glock 17',
  classId: 'pistol',
  caliber: '9x19 mm',
  fireMode: 'semi',
  roundsPerMinute: 450,
  magSize: 17,
  reserveAmmo: 102,
  reloadSeconds: 1.6,
  emptyReloadSeconds: 2.15,
  reloadStyle: 'magazine',
  damage: 26,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 25, zeroMetres: 120, minScale: 0.3 },
  pellets: 1,
  adsSpreadMoa: 4,
  hipSpreadMoa: 90,
  bloomMoaPerShot: 12,
  bloomMoaCap: 60,
  bloomDecayMoaPerSecond: 90,
  moveSpreadMoaPerMps: 14,
  crouchSpreadScale: 0.75,
  airborneSpreadMoa: 60,
  recoilPattern: [
    { pitch: 0.9, yaw: 0.06 },
    { pitch: 0.85, yaw: -0.14 },
    { pitch: 0.82, yaw: 0.1 },
    { pitch: 0.84, yaw: -0.06 },
  ],
  recoilResetSeconds: 0.4,
  recoilRecoveryPerSecond: 8,
  adsFovDegrees: 55,
  adsSeconds: 0.18,
  adsSensitivityScale: 0.75,
  muzzleVelocity: 375,
} as const satisfies WeaponSpec;
